<template>
    <div class="memberBox flex align-items justify-content">
<!--        <img src="@/assets/images/big-logo.png" width="120">-->
    </div>
</template>
<script>
import {
    userLogin,
    // getCode
} from '@/config/api.js'
export default {
  name: 'Login',
    inject:['reload'],
    data () {
      return {
          openid: null,
          unionid: null,
          user_type: null,
          user_id: null,
          is_auth: null,
          is_pass: null,
          auth_token: null,
          rank: null,
          auth_type: null,
          newbie_task: null,
          is_agent: null,
      }
    },
    methods: {
      getCode () {
          if(window.location.href.indexOf('code')>=0) {
              //如果url中包含code,则保存到store中
              let code = window.location.href.split("?code=")[1];
              code = code.substring(0, code.indexOf('&'));
              // this.$store.commit('changeCode',code);
              this.$store.commit('changeCode',code);
          }
          // else{
          //     this.url = getCode;
          //     window.location = this.url;
          // }
      },
        getUser () {
          if (this.$store.state.code) {
              let data = {
                  code:this.$store.state.code
              };
              this.$post(userLogin,data)
                  .then(res => {
                      // this.$message.success(res.msg);
                      let data = res.data;
                      this.openid = data.openid;
                      this.unionid = data.unionid;
                      this.user_type = Number(data.user_type);
                      this.auth_type = Number(data.auth_type);
                      this.is_operater = Number(data.is_operater);
                      this.user_id = Number(data.user_id);
                      this.is_auth = Number(data.is_auth);
                      this.is_pass = Number(data.is_pass);
                      this.auth_token = data.auth_token;
                      this.rank = Number(data.rank);
                      this.newbie_task = Number(data.newbie_task);
                      this.is_agent = Number(data.is_agent);
                      this.is_official = Number(data.is_official);
                      this.$store.commit('changeOpenId',this.openid);
                      this.$store.commit('changeUnionId',this.unionid);
                      this.$store.commit('changeUserType',this.user_type);
                      this.$store.commit('changeAuthType',this.auth_type);
                      this.$store.commit('changeId',this.user_id);
                      this.$store.commit('changeIsOfficial',this.is_operater);
                      this.$store.commit('changeIsAuth',this.is_auth);
                      this.$store.commit('changeIsPass',this.is_pass);
                      this.$store.commit('changeAuthToken',this.auth_token);
                      this.$store.commit('changeRank',this.rank);
                      this.$store.commit('changeNewbieTask',this.newbie_task);
                      this.$store.commit('changeIsAgent',this.is_agent);
                      this.$store.commit('changeIsAgent',this.is_official);
                      this.$store.commit('changeGetTime',new Date());
                      if (this.user_type === 3) {
                          // this.$router.push('/register')
                          this.goReload();
                          setTimeout(() => {
                              window.opener.location.href = '/#/register';
                          },500);
                          this.windowOperator();
                      } else if (this.user_type === 0 && this.is_auth === 0) {
                          // this.$router.push('/enterprise-register/result')
                          this.goReload();
                          setTimeout(() => {
                              window.opener.location.href = '/#/enterprise-register/result';
                          },500);
                          this.windowOperator();
                      } else if (this.user_type === 0 && this.is_auth === 2) {
                          // this.$router.push('/enterprise-register/result')
                          this.goReload();
                          setTimeout(() => {
                              window.opener.location.href = '/#/enterprise-register/result';
                          },500);
                          this.windowOperator();
                      } else if (this.user_type === 0 && this.is_auth === 1 && this.rank === 0) {
                          // this.$router.push('/enterprise-register/result')
                          this.goReload();
                          setTimeout(() => {
                              window.opener.location.href = '/#/enterprise-register/result';
                          },500);
                          this.windowOperator();
                      } else if (this.user_type === 0 && this.is_auth === 1 && this.rank > 0) {
                          // this.$router.push('/enterprise/manage')
                          this.goReload();
                          setTimeout(() => {
                              window.opener.location.href = '/#/enterprise/manage';
                          },500);
                          this.windowOperator();
                      } else if (this.user_type === 1 && this.is_auth === 2) {
                          // this.$router.push('/daren-register/result')
                          this.goReload();
                          setTimeout(() => {
                              window.opener.location.href = '/#/daren-register/result';
                          },500);
                          this.windowOperator();
                      } else if (this.user_type === 1 && this.is_auth === 0 && this.auth_type === 0) {
                          // this.$router.push('/daren-register/select')
                          this.goReload();
                          setTimeout(() => {
                              window.opener.location.href = '/#/daren-register/select';
                          },500);
                          this.windowOperator();
                      } else if (this.user_type === 1 && this.is_auth === 0 && this.auth_type === 1) {
                          // this.$router.push('/daren-register/result')
                          this.goReload();
                          setTimeout(() => {
                              window.opener.location.href = '/#/daren-register/result';
                          },500);
                          this.windowOperator();
                      } else if (this.user_type === 1 && this.is_auth === 1 && this.newbie_task === 0) {
                          // this.$router.push('/daren-register/result')
                          this.goReload();
                          setTimeout(() => {
                              window.opener.location.href = '/#/daren-register/result';
                          },500);
                          this.windowOperator();
                      } else if (this.user_type === 1 && this.is_auth === 1 && this.newbie_task === 1) {
                          // this.$router.push('/daren/manage')
                          this.goReload();
                          setTimeout(() => {
                              window.opener.location.href = '/#/daren/manage';
                          },500);
                          this.windowOperator();
                      } else {
                          this.windowOperator();
                          this.$router.push('/')
                      }
                  })
                  .catch(err => {
                      this.$message.error(err.msg)
                  })
          }
        },
        goReload () {
            window.opener.location.reload();
        },
        windowOperator () {
            setTimeout(() => {
                window.open('','_self','');
                window.close();
            },600)
        }
    },
    created() {
      this.getCode();
      this.getUser()
    }
}
</script>
<style>
  .memberBox{height:100%;background: #fff;}
  #app{height:100%;}
  /*.memberBox ,.loginBox{height:100%;}*/
  /*.login-pic{width:820px;}*/
  /*.login-wrap{width:380px;height:460px;background: #fff;border-radius:5px;}*/
  /*.login-wrap .titleBox{height:60px;border-bottom: 1px #eee solid;padding:0 25px;}*/
  /*.login-wrap .titleBox .title{font-size:16px;line-height:57px;border-bottom: 3px #fe9539 solid;display:inline-block;}*/
  /*.login-wrap .codeBox{text-align: center;}*/
  /*.login-wrap .codeBox .img{margin:30px 0 15px 0;}*/
  /*.login-wrap .codeBox .img img{width:198px;height:198px;border: 1px #eee solid;}*/
  /*.login-wrap .codeBox .text{margin-bottom:15px;}*/
  /*.login-wrap .saoBox{margin-top:20px;}*/
  /*.login-wrap .saoBox .img img{width:40px;height:40px;}*/
  /*.login-wrap .saoBox .text{line-height:22px;margin-left:15px;}*/
  /*.member-footer{background:#fff;width:100%;height:60px;line-height:60px;left:0;bottom:0;}*/
  /*.member-footer .link{color:#666;}*/
  /*.member-footer .link .link-a{margin-right:15px;}*/
  /*.member-footer .copyright{color:#666;}*/
</style>
